import validationRoute from "./validationRoute";

export default async (pattern: String | string, route: any, lookup: Array<{ pattern: String | string, property: String | string }> = [{ pattern: '[id]', property: 'id' }]): Promise<boolean> => {
  const requestRoute = validationRoute(pattern, route, lookup);
  const { status } = await useAsyncData(requestRoute, (ctx?: any) => requestBE(requestRoute));
  return (status.value == 'success');
};
